import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';

import { login, register } from '@/api/user';
import { websiteNavCate } from '@/api/article';
import { urlAndCountBySociety, urlAndCountByCampus, bannerImg } from '@/api/position';
import { update } from '@/api/user-center';

import { setToken, getToken, removeToken } from '@/utils/auth';

Vue.use(Vuex);

const TOKEN_KEY = 'token';
const USER_KEY = 'user';

export default new Vuex.Store({
  state: {
    // 登录token
    token: getToken(TOKEN_KEY),
    // 用户信息
    name: getToken(USER_KEY) && JSON.parse(getToken(USER_KEY)).name ? JSON.parse(getToken(USER_KEY)).name : '',
    avatar: getToken(USER_KEY) && JSON.parse(getToken(USER_KEY)).thumb ? JSON.parse(getToken(USER_KEY)).thumb : '',
    email: getToken(USER_KEY) && JSON.parse(getToken(USER_KEY)).email ? JSON.parse(getToken(USER_KEY)).email : '',
    phone: getToken(USER_KEY) && JSON.parse(getToken(USER_KEY)).phone ? JSON.parse(getToken(USER_KEY)).phone : '',
    // 导航栏分类
    navCate: [],
    // 招聘分类
    recruitCate: [{
      "resmenu_id": "2",
      "pid": "0",
      "title": "",
      "sortid": "",
      "jumpurl": "",
      "status": "",
      "url": "",
      "count": "",
      "pic": "",
      "status": "1",
    }, {
      "resmenu_id": "3",
      "pid": "",
      "title": "",
      "sortid": "",
      "jumpurl": "",
      "status": "",
      "url": "",
      "count": "",
      "pic": "",
      "status": "1",
    }],
  },
  getters: {
    name: (state) => state.name,
    avatar: (state) => state.avatar,
    email: (state) => state.email,
    phone: (state) => state.phone,
    navCate: (state) => state.navCate,
    recruitCate: (state) => state.recruitCate,
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setName(state, name) {
      state.name = name;
    },
    setAvatar(state, avatar) {
      state.avatar = avatar;
    },
    setEmail(state, email) {
      state.email = email;
    },
    setPhone(state, phone) {
      state.phone = phone;
    },
    setNavCate(state, navCate) {
      state.navCate = navCate;
    },
    setRecruitCate(state, recruitCate) {
      state.recruitCate = recruitCate;
    },
  },
  actions: {
    // 初始化数据（导航栏、社会校园招聘外链和数量）
    initialData({ commit, state }) {
      websiteNavCate().then(res => {
        let list = res.data.list.sort((a, b) => Number(a.sortid) - Number(b.sortid));
        // 更新导航分类
        commit('setNavCate', list);

        // 更新招聘
        let temp = [];
        temp = state.navCate.filter(item => {
          if (item.resmenu_id === '2' || item.resmenu_id === '3') {
            item.url = '';
            return item;
          }
        });
        commit('setRecruitCate', temp);
      }).then(() => {
        // 更新社会招聘
        urlAndCountBySociety().then(res => {
          let data = res.data.list[0];
          let temp = state.recruitCate[0];
          temp.url = data.jumpurl;
          temp.count = data.count;
          Vue.set(state.recruitCate, 0, temp);
        });
        // 更新校园招聘
        urlAndCountByCampus().then(res => {
          let data = res.data.list[0];
          let temp = state.recruitCate[1];
          temp.url = data.jumpurl;
          temp.count = data.count;
          Vue.set(state.recruitCate, 1, temp);
        });
        // 更新社会招聘banner图
        bannerImg().then(res => {
          let data = res.data.list;
          let temp;
          let temp2;
          data.forEach(item => {
            switch (item.resmenu_id) {
              case "2":
                temp = state.recruitCate[0];
                temp.pic = item.pic;
                temp.status = item.status;
                Vue.set(state.recruitCate, 0, temp);
                break;

              case "3":
                temp = state.recruitCate[1];
                temp.pic = item.pic;
                temp.status = item.status;
                Vue.set(state.recruitCate, 1, temp);
                break;
            }

            for (let i = 0; i < state.navCate.length; i++) {
              temp2 = state.navCate[i];
              if (temp2.resmenu_id === item.resmenu_id) {
                temp2.pic = item.pic;
                temp2.status = item.status;
                Vue.set(state.navCate, i, temp2);
              }
            }
          });
        });
      });
    },
    // 登录
    login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((res) => {
            // 设置token
            commit('setToken', res.token);
            setToken(TOKEN_KEY, res.token);
            // 设置用户信息
            let { data } = res;
            commit('setName', data.name);
            commit('setAvatar', data.thumb);
            commit('setEmail', data.email);
            commit('setPhone', data.phone);
            setToken(USER_KEY, JSON.stringify(data));

            window.location.reload();
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 注册
    register({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        register(userInfo)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 退出登录
    logOut({ commit }) {
      commit('setToken', '');
      commit('setName', '');
      commit('setAvatar', '');
      commit('setEmail', '');
      commit('setPhone', '');
      removeToken(TOKEN_KEY);
      removeToken(USER_KEY);
      ElementUI.Message.success('退出成功');
      router.push('/');
    },
    // 重置token
    resetToken({ commit }) {
      commit('setToken', '');
      removeToken(TOKEN_KEY);
    },
    // 更新用户信息
    updateInfo({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        update(userInfo)
          .then((res) => {
            commit('setName', userInfo.name);
            commit('setAvatar', userInfo.thumb);
            commit('setEmail', userInfo.email);
            commit('setPhone', userInfo.phone);
            setToken(USER_KEY, JSON.stringify(userInfo));

            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  modules: {},
});
